// Shared Padelante lead options — used by the public lead form (/padelante)
// and by the staff Padelante lead database so both stay in step.

// Playing levels, as per the "Padel playing level table" image served from
// /padel-playing-level-table.jpeg. Value stored on the lead is the rating.
export const PLAYING_LEVELS = [
  ['1.0', 'No experience, just starting to play'],
  ['2.0', 'Can keep a short rally at a low pace'],
  ['2.5', 'Consistent at a medium pace, shots lack direction'],
  ['3.0', 'Building confidence, consistent at a medium pace'],
  ['3.5', 'Control and pace — previous racquet sports players'],
  ['4.0', 'Experience constructing points, generally consistent'],
  ['4.5', 'Resourceful — executes winners and forces errors'],
  ['5.0', 'Experience competing at tournament level'],
  ['5.5', 'Experience competing at a high tournament level'],
  ['6.0', 'Semi-professional, world ranking outside the top 100'],
  ['7.0', 'Professional, ranked inside the world top 100'],
];

// Accommodation options, grouped by hotel. The stored value is the full label.
export const ACCOMMODATION_GROUPS = [
  ['Alicante Golf', [
    'Alicante Golf — single room, 3 nights',
    'Alicante Golf — single room, 2 nights',
    'Alicante Golf — twin room, 3 nights',
    'Alicante Golf — twin room, 2 nights',
  ]],
  ['Castilla', [
    'Castilla — single room, 3 nights',
    'Castilla — single room, 2 nights',
    'Castilla — twin room, 3 nights',
    'Castilla — twin room, 2 nights',
  ]],
];

// "Alicante Golf — twin room, 2 nights" → "twin room, 2 nights"
export const roomLabel = (v) => (v.includes('—') ? v.split('—')[1].trim() : v);

// "3.5" → "3.5 — Control and pace…", so staff don't have to know the ratings
// table by heart. Falls back to whatever is stored for unknown values.
export const levelLabel = (v) => {
  const match = PLAYING_LEVELS.find(([level]) => level === String(v ?? ''));
  return match ? `${match[0]} — ${match[1]}` : (v || '');
};
